import { render, staticRenderFns } from "./InputImgMultiple.vue?vue&type=template&id=32a2cc78&scoped=true"
import script from "./InputImgMultiple.vue?vue&type=script&lang=js"
export * from "./InputImgMultiple.vue?vue&type=script&lang=js"
import style0 from "./InputImgMultiple.vue?vue&type=style&index=0&id=32a2cc78&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a2cc78",
  null
  
)

export default component.exports